<ng-container *ngIf="!isTeaserBet; else teaserSlip">
    <bs-digital-result-succeeded-slip
        *ngFor="let slip of succeededSlips"
        [slip]="slip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [possibleWinningTitle]="possibleWinningTitle"
        [tokenPayoutSummary]="getSlipTokenPayoutSummary(slip)" />
</ng-container>

<ng-template #teaserSlip>
    @if (teasedPoints !== undefined) {
        <bs-digital-result-succeeded-teaser-slip
            *ngFor="let slip of succeededSlips"
            [slip]="slip"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [teasedPoints]="teasedPoints" />
    }
</ng-template>
